import { firebaseDb } from "../firebase";
import { pick } from "lodash";
import intercomBoot from "../../lib/intercomBoot";
import { STORE_USER_SUCCESS, LOAD_USER_SUCCESS } from "./action-types";

function extractUserProperties(firebaseUser) {
  const userProperties = ["displayName", "email", "photoURL", "uid"];

  return pick(firebaseUser, userProperties);
}

export function userSignedIn(user) {
  return (dispatch) => {
    const userRef = firebaseDb.ref(`/user/${user.uid}/info`);
    userRef.on("value", (snapshot) => {
      const userInfo = pick(snapshot.val(), [
        "displayName",
        "email",
        "photoURL",
        "uid",
      ]);

      firebaseDb.ref(`/user/${user.uid}/affiliate`).on("value", (snapshot) => {
        const affiliate = snapshot.val();
        firebaseDb.ref(`/user/${user.uid}/cyclone`).on("value", (snapshot) => {
          const cyclone = snapshot.val();
          if (affiliate) {
            dispatch(loadUserSuccess({ ...userInfo, affiliate, cyclone }));
          } else {
            dispatch(
              loadUserSuccess({ ...userInfo, affiliate: null, cyclone })
            );
          }
        });
      });
    });
  };
}

export function storeUser(user) {
  return (dispatch) => {
    const userRef = firebaseDb.ref(`/user/${user.uid}/info`);
    userRef.set(extractUserProperties(user), (err) => {
      if (!err) {
        fetch(
          `https://us-central1-project-1029735015520686877.cloudfunctions.net/updateUserInfo?uid=${user.uid}`,
          {
            mode: "cors",
          }
        ).then(() => {
          intercomBoot(user);
          dispatch(storeUserSuccess());
        });
      }
    });
  };
}

export function storeUserSuccess() {
  return {
    type: STORE_USER_SUCCESS,
  };
}

export function loadUserSuccess(user) {
  return {
    type: LOAD_USER_SUCCESS,
    payload: user,
  };
}



/** WEBPACK FOOTER **
 ** ./src/core/user/actions.js
 **/